import { FunctionComponent } from 'react'

import styled from 'styled-components'

import { SportTableInlineProps } from '@widgets/SportTableInline/types'
import FreeRatioImage from '@components/FreeRatioImage'

export type SponsorLogoProps = {
  image: Required<Pick<SportTableInlineProps, 'sponsor'>>['sponsor']['image']
}

const StyledSponsorLogo = styled.div`
  align-items: center;
  background-color: transparent;
  display: flex;
  justify-content: center;
  height: 24px;
`

const constraintParams = {
  width: 150,
  height: 24,
}

const constraints = {
  desktop: constraintParams,
  tablet: constraintParams,
  mobile: constraintParams,
  mobileSmall: constraintParams,
}

const SponsorLogo: FunctionComponent<SponsorLogoProps> = ({ image }) => {
  const { alt, crops, height, src, width } = image || {}

  return (
    <StyledSponsorLogo>
      <FreeRatioImage
        alt={alt}
        constraints={constraints}
        crops={crops ?? {}}
        originalDimensions={{ width, height }}
        src={src}
      />
    </StyledSponsorLogo>
  )
}

export default SponsorLogo
